import { Form, Formik } from "formik";
import * as Yup from "yup";

import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import "./OrgManipulation.css";
import { useState } from "react";
import { useAxiosPostDictionary } from "../../Api/ApiDictionary/axiosPostAddNewElementDictionary";

import closeIcon from "../../img/closeIcon.svg";
import editIcon from "../../img/editIcon.svg";
import { useAxiosPutDictionary } from "../../Api/ApiDictionary/axiosPutDictionary";

export function OrgManipulation() {
  const { dictionaryOrg: orgs } = useAuth();
  const [editId, setEditId] = useState(undefined);

  return (
    <div className="profile-org-manipulation">
      <h4 className="profile-user-title">Organizations manipulation:</h4>
      <label className="profile-org-manipulation__label">Organizations</label>
      <ul className="profile-org-manipulation__list">
        {orgs.map((org) => (
          <li key={org.id}>
            <div className="profile-org-manipulation__list-item-description">
              <p>{org.name}</p>
              <p>Address : {org.address}</p>
            </div>
            <img
              onClick={() => setEditId(org.id)}
              width="25px"
              height="25px"
              src={editIcon}
              alt="edit"
            />
          </li>
        ))}
      </ul>
      <button
        onClick={() => setEditId(null)}
        className="profile-org-manipulation__add"
      >
        Add new +
      </button>
      <OrgModal id={editId} onCloseModal={() => setEditId(undefined)} />
    </div>
  );
}

/**
 * Modal that is used to create new organizations + edit old ones
 * id - string if editing existing org !!!NOT IMPLEMENTED!!!
 * id - null if creating new
 * id - undefined if modal closed
 * @param {{
 *  id : string | null | undefined
 *  onCloseModal : () => void
 * }} props
 * @returns {import("react").ReactNode | null}
 */

function OrgModal({ id, onCloseModal }) {
  const axios = useAxiosPrivate();

  const addOrg = useAxiosPostDictionary(axios, "organization");
  const editOrg = useAxiosPutDictionary(axios, "organization");

  const org = useAuth().dictionaryOrg.find((org) => org.id === id);

  if (id === undefined) return null;

  return (
    <Formik
      initialValues={{
        name: org?.name ?? "",
        address: org?.address ?? "",
      }}
      validationSchema={Yup.object({
        name: Yup.string().required(),
        address: Yup.string().required(),
      })}
      onSubmit={(values) => {
        (id === null ? addOrg(values) : editOrg(id, values))
          .then(onCloseModal)
          .catch((err) => console.log(err));
      }}
    >
      {({ handleChange, handleBlur, values, errors, touched }) => (
        <div className="profile-org-manipulation__modal-container">
          <div className="profile-org-manipulation__modal">
            <header className="profile-org-manipulation__modal-header">
              <h4 className="profile-user-title">Organization editor: </h4>
              <img
                onClick={onCloseModal}
                src={closeIcon}
                alt=""
                width="20px"
                height="20px"
              />
            </header>
            <Form>
              <div className="profile-user-input__field">
                <label className="profile-user-input__label">Name</label>
                <input
                  className="profile-user-assign-roles-user__input"
                  name="name"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="ORG1"
                />
                {errors.name && touched.name ? (
                  <p className="profile-org-manipulation__error">
                    {errors.name}
                  </p>
                ) : null}
              </div>
              <div className="profile-user-input__field">
                <label className="profile-user-input__label">Address</label>
                <input
                  className="profile-user-assign-roles-user__input"
                  name="address"
                  value={values.address}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="ADDR1"
                />
                {errors.address && touched.address ? (
                  <p className="profile-org-manipulation__error">
                    {errors.address}
                  </p>
                ) : null}
              </div>
              <div className="profile-org-manipulation__save-wrapper">
                <button
                  disabled={Object.keys(errors).length}
                  className="profile-org-manipulation__save"
                  type="submit"
                >
                  Save
                </button>
              </div>
            </Form>
          </div>
        </div>
      )}
    </Formik>
  );
}
